<template>
  <div
    :style="{ backgroundImage: `url(${require('@/assets/images/top-page-title.jpg')})` }"
    class="TopPageSection text-white bg-no-repeat bg-bottom bg-cover border-b-4 border-dark-red"
  >
    <div
      v-if="separator"
      class="separator pt-l"
    />
    <slot/>
  </div>
</template>

<script>
/**
 * @module TopPageSection
 */
export default {
  name: 'TopPageSection',
  props: {
    separator: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
